import { PartialType, ApiPropertyOptional } from '@nestjs/swagger'
import { IsUUID, IsOptional } from 'class-validator'
import { CreateProgramConceptDto } from './create-program-concept.dto'

export class UpdateProgramConceptDto extends PartialType(
  CreateProgramConceptDto
) {
  @ApiPropertyOptional({ description: 'Program version UUID' })
  @IsUUID()
  @IsOptional()
  override programVersionId?: string

  @ApiPropertyOptional({ description: 'Concept UUID' })
  @IsUUID()
  @IsOptional()
  override conceptId?: string
}
